import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=0c1586ba&lang=pug&"
import script from "./GroupsList.vue?vue&type=script&lang=ts&"
export * from "./GroupsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports